import { render } from "./Publicos.vue?vue&type=template&id=b7a5d7ec&scoped=true"
import script from "./Publicos.vue?vue&type=script&lang=js"
export * from "./Publicos.vue?vue&type=script&lang=js"

import "./Publicos.vue?vue&type=style&index=0&id=b7a5d7ec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7a5d7ec"]])

export default __exports__